import { render, staticRenderFns } from "./CompanyIntroduction.vue?vue&type=template&id=bd561194&scoped=true&"
import script from "./CompanyIntroduction.vue?vue&type=script&lang=js&"
export * from "./CompanyIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntroduction.vue?vue&type=style&index=0&id=bd561194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd561194",
  null
  
)

export default component.exports